import { render, staticRenderFns } from "./personalizacao-footer-actions.vue?vue&type=template&id=052476e3&scoped=true&"
import script from "./personalizacao-footer-actions.vue?vue&type=script&lang=js&"
export * from "./personalizacao-footer-actions.vue?vue&type=script&lang=js&"
import style0 from "./personalizacao-footer-actions.vue?vue&type=style&index=0&id=052476e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052476e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052476e3')) {
      api.createRecord('052476e3', component.options)
    } else {
      api.reload('052476e3', component.options)
    }
    module.hot.accept("./personalizacao-footer-actions.vue?vue&type=template&id=052476e3&scoped=true&", function () {
      api.rerender('052476e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/views/crm/view-crm-personalizacao/personalizacao-footer-actions.vue"
export default component.exports